import { checkReservationExists, checkWorker, getReservationsByTask } from "../../ActionUtils";
import { Task } from "~/packages/taskrouter";
import { ErrorCode, ErrorSeverity } from "~/modules/error";
import { getLogger, LoggerName } from "~/modules/logger";
import { TaskRouterImpl } from "~/packages/taskrouter/TaskRouterImpl";

import { ContextInstance, ContextManager } from "~/modules/contextManager/ContextManager";
import { sendWorkerTrackingEvent, toCauseMessage } from "~/modules/telemetry/utils";
import { EVENTS } from "~/modules/telemetry/Analytics";
import { AnalyticsImpl } from "~/modules/telemetry/AnalyticsImpl";
import { CbmImpl } from "~/modules/cbm/CbmImpl";
import { Action } from "~/modules/actions/Action";
import { throwFlexSdkError } from "~/modules/error/ThrowError/ErrorHelper";






























export class EndVoiceCallForAll implements Action<Promise<Task>> {
    


    readonly #taskSid: string;

    constructor(taskSid: string) {
        this.#taskSid = taskSid;
    }

    async run(ctx: {}) {
        const context = ctx as ContextManager;
        const taskRouter = context.retrieveInstanceOf(ContextInstance.TaskRouter, TaskRouterImpl);
        await taskRouter.init();
        const logger = getLogger(context)(LoggerName.Actions);
        const worker = taskRouter.worker;
        const analytics = context.retrieveInstanceOf(ContextInstance.AnalyticsImpl, AnalyticsImpl);
        const cbm = context.retrieveInstanceOf(ContextInstance.CbmImpl, CbmImpl);
        await cbm.init();

        logger.debug(`endVoiceCallForAll invoked with taskSid: ${this.#taskSid}`);

        checkWorker(worker, {
            actionName: "EndVoiceCallForAll",
            moduleName: "actions/Voice",
            logger,
            analytics,
            context,
            event: EVENTS.EndVoiceCallForAllCompleted,
            extra: {
                taskSid: this.#taskSid
            },
            worker
        });

        const reservations = getReservationsByTask(worker, this.#taskSid);
        const acceptedReservations = reservations.filter((res) => res.status === "accepted");
        const reservation = acceptedReservations[0];

        checkReservationExists(reservation, this.#taskSid, {
            actionName: "EndVoiceCallForAll",
            moduleName: "actions/Voice",
            logger,
            analytics,
            context,
            event: EVENTS.EndVoiceCallForAllCompleted,
            extra: {
                taskSid: this.#taskSid
            },
            worker
        });

        try {
            const { task } = await cbm.endConference(reservation);
            sendWorkerTrackingEvent(EVENTS.EndVoiceCallForAllCompleted, analytics, worker, {
                taskSid: this.#taskSid,
                reservationSid: reservation.sid
            });
            return task;
        } catch (error) {
            const errorMsg = `EndVoiceCallForAll: Failed to end conference for task ${this.#taskSid} (reservation ${
                reservation?.sid
            })`;
            logger.error(errorMsg, error);
            sendWorkerTrackingEvent(EVENTS.UnholdVoiceParticipantCompleted, analytics, worker, {
                error: `${errorMsg} (${toCauseMessage(error)})`
            });
            return throwFlexSdkError(context)(
                ErrorCode.FailedToEndConference,
                { severity: ErrorSeverity.Error },
                errorMsg,
                error
            );
        }
    }
}
